/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { ExcludedProfileAdd } from './excludedProfileAdd';

export interface AddExcludedPeopleRequest {
  /**
     * @minItems 1
     * @maxItems 500
     */
  items: ExcludedProfileAdd[];
}
